import { dom as domEn } from 'lang/en/dom';
import { translations as translationsEn } from 'lang/en/translations';
import { dom as domIt } from 'lang/it/dom';
import { translations as translationsIt } from 'lang/it/translations';

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

/**
 * i18next configured for the Electron export.
 *
 * The resources are imported statically as ES modules and are therefore
 * inlined into the JS bundle by webpack (CRA). There is NO runtime
 * file-system or HTTP loading (no i18next-http-backend / fs-backend), which is
 * exactly what used to break inside the packaged Electron app: there the
 * renderer runs under file:// (inside app.asar) and a runtime
 * fetch('/locales/{lng}/{ns}.json') fails silently.
 *
 * With bundled resources the behaviour is identical in the browser and in the
 * packaged Electron app.
 */
i18n.use(initReactI18next).init({
  resources: {
    it: { translation: translationsIt, dom: domIt },
    en: { translation: translationsEn, dom: domEn },
  },
  lng: 'it',
  fallbackLng: 'it',
  ns: ['translation', 'dom'],
  defaultNS: 'translation',
  // Our keys are FLAT strings that contain literal dots and dashes
  // (e.g. 'propertyUnit.floor', 'availabilityStatuses.deal-closed'). They are
  // not nested objects, so the default '.'/':' separators must be disabled or
  // i18next would try to resolve them as nested paths / namespaces.
  keySeparator: false,
  nsSeparator: false,
  interpolation: {
    // React already escapes the output it renders, and some strings are
    // intentionally injected as HTML (e.g. `fullscreenAlert` via
    // dangerouslySetInnerHTML), so i18next must return raw values.
    escapeValue: false,
  },
  returnNull: false,
  // Resources are bundled and available synchronously, so there is nothing to
  // wait for: disable Suspense to avoid any fallback during render or when the
  // language changes.
  react: { useSuspense: false },
});

export default i18n;
